/* ch2-erd.js — header drawer, sticky behaviour, hero sound toggle. */
(function () {
  'use strict';

  // Several sections each emit a <script src> for this file, and duplicate
  // script tags with the same src DO both execute — which bound every handler
  // twice and made each accordion click toggle and untoggle. Run once only.
  if (window.__ch2ErdInit) return;
  window.__ch2ErdInit = true;

  /* ---------- mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-ch2-drawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-ch2-drawer-open]');
    var stage = drawer.querySelector('[data-ch2-stage]');
    var lastFocus = null;

    // Shopify wraps each section in a #shopify-section-* div, and the header
    // group's wrapper carries a z-index — which caps everything inside it, so
    // the fixed drawer loses to page content painted later. Re-parent it to
    // <body> so its own z-index actually applies.
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);

    function open() {
      lastFocus = document.activeElement;
      drawer.setAttribute('data-open', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ch2-no-scroll');
      var first = drawer.querySelector('a, button, input');
      if (first) first.focus();
    }
    function closeSub() {
      if (stage) stage.setAttribute('data-sub', '');
      drawer.querySelectorAll('[data-ch2-sub-panel]').forEach(function (p) {
        p.classList.remove('is-active');
      });
      drawer.querySelectorAll('[data-ch2-sub-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }

    function close() {
      drawer.setAttribute('data-open', 'false');
      closeSub();
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ch2-no-scroll');
      if (lastFocus) lastFocus.focus();
    }

    Array.prototype.forEach.call(openers, function (btn) {
      btn.addEventListener('click', open);
    });
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-ch2-drawer-close]'), function (btn) {
      btn.addEventListener('click', close);
    });
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-ch2-sub-open]'), function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-ch2-sub-open');
        var panel = drawer.querySelector('[data-ch2-sub-panel="' + id + '"]');
        if (!panel || !stage) return;
        closeSub();
        stage.setAttribute('data-sub', id);
        panel.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
        panel.scrollTop = 0;
        var first = panel.querySelector('button, a');
        if (first) first.focus();
      });
    });
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-ch2-sub-close]'), function (btn) {
      btn.addEventListener('click', closeSub);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || drawer.getAttribute('data-open') !== 'true') return;
      if (stage && stage.getAttribute('data-sub') !== '') closeSub();
      else close();
    });
    // Close the drawer if the viewport grows past the desktop breakpoint.
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1024 && drawer.getAttribute('data-open') === 'true') close();
    });
  }

  /* ---------- sticky header: solid once scrolled, hide on scroll down ---------- */
  function initHeader() {
    var header = document.querySelector('[data-ch2-header]');
    if (!header) return;
    var transparent = header.getAttribute('data-transparent') === 'true';

    // The CSS variable is only a first guess; the real height depends on the
    // logo and font. Everything that offsets against the header — the page's
    // top padding, the dropdown's top edge, the drawer — reads this variable.
    function measure() {
      document.documentElement.style.setProperty('--ch2-header-h', header.offsetHeight + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

    var last = window.pageYOffset;
    var ticking = false;

    function update() {
      var y = window.pageYOffset;
      if (!transparent || y > 40) header.classList.add('ch2-header--solid');
      else header.classList.remove('ch2-header--solid');

      if (y > last && y > 200) header.classList.add('ch2-header--hidden');
      else header.classList.remove('ch2-header--hidden');

      last = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- hero video sound toggle ---------- */
  function initHero() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ch2-sound]'), function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var video = document.getElementById(btn.getAttribute('data-ch2-sound'));
        if (!video) return;
        video.muted = !video.muted;
        btn.setAttribute('aria-pressed', String(!video.muted));
        btn.querySelector('[data-ch2-sound-label]').textContent = video.muted ? 'Sound on' : 'Sound off';
        if (!video.muted) video.play();
      });
    });
  }

  /* ---------- desktop nav dropdown ---------- */
  function initDropdown() {
    var items = document.querySelectorAll('[data-ch2-dropdown-for]');
    if (!items.length) return;
    var header = document.querySelector('[data-ch2-header]');
    var underlay = document.querySelector('[data-ch2-dropdown-underlay]');
    var openId = null;
    var closeTimer = null;

    function close() {
      document.querySelectorAll('[data-ch2-dropdown]').forEach(function (p) {
        p.setAttribute('data-open', 'false');
      });
      items.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      if (underlay) underlay.setAttribute('data-open', 'false');
      if (header) header.classList.remove('ch2-header--dropdown');
      openId = null;
    }

    function open(id, trigger) {
      if (openId === id) return;
      close();
      var panel = document.getElementById(id);
      if (!panel) return;
      panel.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      if (underlay) underlay.setAttribute('data-open', 'true');
      if (header) header.classList.add('ch2-header--dropdown');
      openId = id;
    }

    function cancelClose() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }
    function deferClose() { cancelClose(); closeTimer = setTimeout(close, 120); }

    items.forEach(function (trigger) {
      var id = trigger.getAttribute('data-ch2-dropdown-for');
      trigger.addEventListener('mouseenter', function () { cancelClose(); open(id, trigger); });
      trigger.addEventListener('focus', function () { cancelClose(); open(id, trigger); });
      trigger.addEventListener('mouseleave', deferClose);

      var panel = document.getElementById(id);
      if (panel) {
        panel.addEventListener('mouseenter', cancelClose);
        panel.addEventListener('mouseleave', deferClose);
      }
    });

    if (underlay) underlay.addEventListener('mouseenter', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- product page: size choice, add to cart, accordion ---------- */
  function initProduct() {
    var form = document.querySelector('[data-ch2-product-form]');
    if (form) {
      var idInput = form.querySelector('[data-ch2-variant-id]');
      var priceEl = document.querySelector('[data-ch2-price]');
      var button = form.querySelector('[data-ch2-atc]');
      var errorEl = form.querySelector('[data-ch2-error]');
      var soldOut = button ? button.getAttribute('data-sold-out-text') || 'Sold out' : '';

      form.querySelectorAll('input[name="ch2-size"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          idInput.value = radio.value;
          if (priceEl) {
            var compare = radio.getAttribute('data-compare');
            priceEl.innerHTML = (compare ? '<del>' + compare + '</del> ' : '') + radio.getAttribute('data-price');
          }
          if (errorEl) errorEl.textContent = '';
          // Keep the URL shareable — the server pre-selects from ?variant=.
          var url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url);
        });
      });

      form.addEventListener('submit', function (e) {
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        // Without a drawer, let the browser post the form and land on /cart.
        if (!cart || typeof cart.renderContents !== 'function') return;

        e.preventDefault();
        if (button.getAttribute('aria-disabled') === 'true') return;
        button.classList.add('is-loading');
        if (errorEl) errorEl.textContent = '';

        var body = new FormData(form);
        body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        body.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) {
              if (errorEl) errorEl.textContent = data.description || data.message || soldOut;
              return;
            }
            cart.renderContents(data);
          })
          .catch(function () {
            if (errorEl) errorEl.textContent = 'Something went wrong. Please try again.';
          })
          .finally(function () { button.classList.remove('is-loading'); });
      });
    }

    /* Info sheets.

       Below 1024px this is a bottom sheet with two resting states: `peek`
       (as tall as its content, capped at 80% of the viewport) and `full`. The
       panel itself is always 100dvh; --ch2-sheet-y translates it down so only
       the peek portion shows. That keeps the drag a pure transform, which a
       height animation could never be, and makes "drag up to read it all" a
       one-line change of that variable.

       From 1024px it is a right-hand sidebar and none of this runs. */
    var openSheet = null;
    var sheetOpener = null;
    var mqSheetDrag = window.matchMedia('(max-width: 1023px)');

    function sheetPanel(sheet) { return sheet.querySelector('.ch2-sheet__panel'); }

    /* How far down to push the full-height panel so only the content shows. */
    function peekOffset(sheet) {
      var inner = sheet.querySelector('.ch2-sheet__inner');
      var grab = sheet.querySelector('.ch2-sheet__grab');
      var vh = window.innerHeight;
      var content = (grab ? grab.offsetHeight : 0) + (inner ? inner.offsetHeight : 0);
      return Math.max(0, vh - Math.min(content, vh * 0.8));
    }

    function setSheetY(sheet, y) {
      sheet.style.setProperty('--ch2-sheet-y', Math.round(y) + 'px');
    }

    function applyState(sheet, state) {
      sheet.setAttribute('data-state', state);
      var grab = sheet.querySelector('.ch2-sheet__grab');
      if (grab) grab.setAttribute('aria-expanded', state === 'full' ? 'true' : 'false');
      setSheetY(sheet, state === 'full' ? 0 : peekOffset(sheet));
    }

    function closeSheet() {
      if (!openSheet) return;
      openSheet.setAttribute('data-open', 'false');
      openSheet.setAttribute('aria-hidden', 'true');
      openSheet.removeAttribute('data-dragging');
      document.body.classList.remove('ch2-no-scroll');
      if (sheetOpener) sheetOpener.focus();
      openSheet = null;
      sheetOpener = null;
    }

    /* ----- drag ----- */
    var drag = null;

    function currentY(sheet) {
      var v = parseFloat(getComputedStyle(sheet).getPropertyValue('--ch2-sheet-y'));
      return isNaN(v) ? 0 : v;
    }

    function dragStart(e, sheet, fromGrab) {
      if (!mqSheetDrag.matches || e.button > 0) return;
      var panel = sheetPanel(sheet);
      // From the body we may only take over a downward drag, and only when the
      // panel is already scrolled to the top - otherwise this is a scroll.
      if (!fromGrab && panel.scrollTop > 0) return;
      drag = {
        sheet: sheet, panel: panel, fromGrab: fromGrab,
        startY: e.clientY, baseY: currentY(sheet),
        lastY: e.clientY, lastT: e.timeStamp, vy: 0,
        active: fromGrab, pointerId: e.pointerId
      };
      if (fromGrab) {
        sheet.setAttribute('data-dragging', 'true');
        if (e.target.setPointerCapture) e.target.setPointerCapture(e.pointerId);
      }
    }

    function dragMove(e) {
      if (!drag) return;
      var dy = e.clientY - drag.startY;

      // A body drag only becomes a sheet drag once it is clearly downward.
      if (!drag.active) {
        if (dy < 6) return;
        drag.active = true;
        drag.sheet.setAttribute('data-dragging', 'true');
      }

      var dt = e.timeStamp - drag.lastT;
      if (dt > 0) drag.vy = (e.clientY - drag.lastY) / dt;
      drag.lastY = e.clientY;
      drag.lastT = e.timeStamp;

      var y = drag.baseY + dy;
      if (y < 0) y = y / 4;                       // resistance past full height
      setSheetY(drag.sheet, Math.min(y, window.innerHeight));
      if (e.cancelable) e.preventDefault();
    }

    function dragEnd() {
      if (!drag) return;
      var sheet = drag.sheet;
      var wasActive = drag.active;
      var vy = drag.vy;
      drag = null;
      sheet.removeAttribute('data-dragging');
      if (!wasActive) return;

      var y = currentY(sheet);
      var peek = peekOffset(sheet);
      var vh = window.innerHeight;

      // A flick beats distance; otherwise go by where it was let go.
      if (vy > 0.6) {
        if (sheet.getAttribute('data-state') === 'full' && y < peek) applyState(sheet, 'peek');
        else closeSheet();
      } else if (vy < -0.6) {
        applyState(sheet, 'full');
      } else if (y > peek + Math.min(120, vh * 0.15)) {
        closeSheet();
      } else if (y < peek * 0.5) {
        applyState(sheet, 'full');
      } else {
        applyState(sheet, 'peek');
      }
    }

    document.querySelectorAll('[data-ch2-sheet]').forEach(function (sheet) {
      // Same stacking-context problem as the drawer: a section wrapper with a
      // z-index would trap this, so hoist it to <body>.
      if (sheet.parentElement !== document.body) document.body.appendChild(sheet);
      sheet.querySelectorAll('[data-ch2-sheet-close]').forEach(function (btn) {
        btn.addEventListener('click', closeSheet);
      });

      var grab = sheet.querySelector('[data-ch2-sheet-grab]');
      if (grab) {
        grab.addEventListener('pointerdown', function (e) { dragStart(e, sheet, true); });
        // A tap that never turned into a drag toggles instead.
        grab.addEventListener('click', function () {
          if (!mqSheetDrag.matches) return;
          applyState(sheet, sheet.getAttribute('data-state') === 'full' ? 'peek' : 'full');
        });
      }
      sheetPanel(sheet).addEventListener('pointerdown', function (e) {
        if (e.target.closest('[data-ch2-sheet-grab], a')) return;
        dragStart(e, sheet, false);
      });
    });

    document.addEventListener('pointermove', dragMove, { passive: false });
    document.addEventListener('pointerup', dragEnd);
    document.addEventListener('pointercancel', dragEnd);

    document.querySelectorAll('[data-ch2-sheet-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sheet = document.querySelector('[data-ch2-sheet="' + btn.getAttribute('data-ch2-sheet-open') + '"]');
        if (!sheet) return;
        closeSheet();
        sheet.setAttribute('data-open', 'true');
        sheet.setAttribute('aria-hidden', 'false');
        document.body.classList.add('ch2-no-scroll');
        sheetPanel(sheet).scrollTop = 0;
        // Measure only once the panel is visible, or offsetHeight reads 0.
        applyState(sheet, 'peek');
        var close = sheet.querySelector('.ch2-sheet__close');
        if (close) close.focus();
        openSheet = sheet;
        sheetOpener = btn;
      });
    });

    // Crossing the sidebar breakpoint, or a phone rotating, invalidates the
    // measured offset.
    window.addEventListener('resize', function () {
      if (openSheet) applyState(openSheet, openSheet.getAttribute('data-state'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheet();
    });
  }

  /* ---------- PDP gallery controls ----------
     The sideways swipe is pure CSS scroll-snap; this keeps the dashes and the
     thumbnail strip in step with it, and lets a thumbnail drive the gallery.

     A passive scroll listener rather than IntersectionObserver: IO delivers on
     the rendering step, so it goes silent whenever the page is not painting
     and the indicator comes back wrong. scrollLeft is always current. */
  function initGallery() {
    var gallery = document.querySelector('[data-ch2-gallery]');
    if (!gallery) return;

    var figures = gallery.querySelectorAll('figure');
    if (figures.length < 2) return;

    var lineWrap = document.querySelector('[data-ch2-lines]');
    var thumbWrap = document.querySelector('[data-ch2-thumbs]');
    var lines = lineWrap ? lineWrap.querySelectorAll('.ch2-pdp__line') : [];
    var thumbs = thumbWrap ? thumbWrap.querySelectorAll('.ch2-pdp__thumb') : [];

    var current = -1;
    function sync() {
      var w = gallery.clientWidth;
      if (!w) return;
      var i = Math.round(gallery.scrollLeft / w);
      if (i < 0) i = 0;
      if (i > figures.length - 1) i = figures.length - 1;
      if (i === current) return;
      current = i;

      for (var n = 0; n < lines.length; n++) lines[n].classList.toggle('is-active', n === i);
      for (var m = 0; m < thumbs.length; m++) thumbs[m].setAttribute('aria-current', m === i ? 'true' : 'false');

      // Keep the current thumbnail in view — iamgia's align-selected. Only
      // nudge the strip itself, never the page.
      var active = thumbs[i];
      if (active && thumbWrap.scrollWidth > thumbWrap.clientWidth) {
        var left = active.offsetLeft - (thumbWrap.clientWidth - active.offsetWidth) / 2;
        thumbWrap.scrollTo({ left: left, behavior: 'smooth' });
      }
    }

    gallery.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].addEventListener('click', function () {
        var i = parseInt(this.getAttribute('data-index'), 10);
        if (isNaN(i)) return;
        gallery.scrollTo({ left: gallery.clientWidth * i, behavior: 'smooth' });
      });
    }

    sync();
  }

  /* ---------- quick add on product cards ----------
     One delegated listener, so cards rendered later (search, pagination) work
     without re-binding. Adds through Dawn's cart drawer exactly like the PDP. */
  function initQuickAdd() {
    function closeAll(except) {
      document.querySelectorAll('[data-ch2-qa].is-open').forEach(function (qa) {
        if (qa === except) return;
        qa.classList.remove('is-open');
        var t = qa.querySelector('[data-ch2-qa-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    function add(qa, id) {
      var errorEl = qa.querySelector('[data-ch2-qa-error]');
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var item = { id: Number(id), quantity: 1 };
      // Pre-order cards carry the ship time, so the order says what it is.
      if (qa.dataset.preorder) item.properties = { 'Pre-order': qa.dataset.preorder };
      var body = { items: [item] };
      if (cart && typeof cart.renderContents === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      qa.classList.add('is-busy');
      if (errorEl) errorEl.textContent = '';

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            if (errorEl) errorEl.textContent = data.description || data.message || 'Sold out';
            else window.alert(data.description || data.message);
            return;
          }
          closeAll();
          if (cart && typeof cart.renderContents === 'function' && data.sections) {
            // renderContents reads .id for the notification's product focus.
            if (data.items && data.items[0]) data.id = data.items[0].id;
            cart.renderContents(data);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          if (errorEl) errorEl.textContent = 'Something went wrong. Please try again.';
        })
        .finally(function () { qa.classList.remove('is-busy'); });
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-ch2-qa-toggle]');
      var sizeBtn = e.target.closest('[data-ch2-qa-add]');
      if (toggle) {
        e.preventDefault();
        var qa = toggle.closest('[data-ch2-qa]');
        if (qa.hasAttribute('data-single-id')) { add(qa, qa.getAttribute('data-single-id')); return; }
        var open = !qa.classList.contains('is-open');
        closeAll(qa);
        qa.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        return;
      }
      if (sizeBtn) {
        e.preventDefault();
        add(sizeBtn.closest('[data-ch2-qa]'), sizeBtn.getAttribute('data-ch2-qa-add'));
        return;
      }
      if (!e.target.closest('[data-ch2-qa-panel]')) closeAll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  /* ---------- collection sort + filter ---------- */
  function initFacets() {
    // Blank price boxes would be sent as empty filter params; drop them.
    function dropBlank(form) {
      form.querySelectorAll('input[type="number"]').forEach(function (i) { if (!i.value) i.disabled = true; });
    }
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-ch2-sort]')) return;
      var form = e.target.closest('form');
      dropBlank(form);
      form.submit();
    });
    document.addEventListener('submit', function (e) {
      if (e.target.matches('[data-ch2-facets]')) dropBlank(e.target);
    });
  }

  function init() { initFacets(); initQuickAdd(); initDrawer(); initHeader(); initHero(); initDropdown(); initProduct(); initGallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
